<template>
  <section id="about" class="about" v-waypoint="{ active: true, callback: onScroll, options: scrollOptions}">
    <flowerbackground />
    <div class="container">
      <div class="greeting">
        <h1>Hello</h1>
        <small>Marina Coetzee, Marketing Fundi</small>
        <p>
          “What got you here, won’t get you there...”. That is the quote that inspired me to make a change. Growing up in an entrepreneurial family gave me a head start and guided my studies and career path that followed, specializing in Marketing and Entrepreneurship.
          <br><br>At Consultancy Squad, we have a passion for small and medium businesses to grow their dream to levels that would exceed even their highest expectations. Consider us an extension of your team – your own personal fundi's, available every day. We are truly the best and capable of giving big businesses a run for their money.
        </p>
        <div class="greeting-image" />
      </div>

      <div class="value">
        <h1>Values</h1>
        <div class="value-text">
          <p>
            We are all about value and convenience, providing you with a variety of services from one agency. Using us will not only save you precious time and money, but without a doubt, limit stress and frustration too. Let us take care of your Marketing needs, so that you can focus on making the money. Integrity is the name of our game. You can expect an assertive team, who has you as our number one priority. A team that is a mere extension of yours and that will never settle for anything less than perfection. A team that pushes boundaries and take calculated risks for maximum return.
          </p>
        </div>
        <ul class="value-cards">
          <li>
            <p>Integrity</p>
            <small>Strong Moral Principles</small>
          </li>
          <li>
            <p>Value</p>
            <small>Going the Extra Mile</small>
          </li>
          <li>
            <p>Convenience</p>
            <small>We Take Care of Everything</small>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
// Modules
import { gsap, CSSRulePlugin } from 'gsap/all'

// Components
import flowerbackground from './components/flower-background.vue'
export default {
  components: {
    flowerbackground
  },
  data: () => ({
    scrollOptions: {
      root: null,
      rootMargin: '-137.5px 0px 0px 0px',
      threshold: [0.5, 0.5]
    }
  }),
  mounted () {
    gsap.registerPlugin(CSSRulePlugin)
  },
  methods: {
    onScroll ({ going, direction }) {
      // const background = CSSRulePlugin.getRule('.about:after')
      if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM) {
        gsap.fromTo('.greeting p', 1, {
          cssRule: {
            background: 'red'
          }
        }, {
          cssRule: {
            background: 'blue'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables';
@import "../../assets/styles/breakpoints";
.about {
  position: relative;
  .background-flower {
    position: absolute;
    display: inline-block;
    left: 0;
    top: -150px;
    max-width: 250px;
    min-width: 150px;
    width: 15%;
    @include breakpoint(md) {
      display: none;
    }
  }
  .greeting {
    margin: 200px 0;
    position: relative;
    display: flex;
    align-items: center;
    @include breakpoint(md) {
      display: block;
      padding-top: 50px;
    }
    .greeting-image {
      border: 10px solid $white;
      flex: 0 0 300px;
      width: 300px;
      min-height: 400px;
      background-image: url('../../assets/images/mariena-coetzee.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-color: $white;
      box-shadow: 0px 0px 15px 3px rgba($black, 0.2);
      margin: -20px 40px -20px 30px;
      @include breakpoint(md) {
        position: relative;
        background-position: center;
        bottom: -40px;
        margin: 20px;
        width: calc(100% - 60px);
      }
      @include breakpoint(sm) {
        min-height: 300px;
        width: calc(100% - 60px);
        bottom: -40px;
        margin: 20px;
      }
    }
    p {
      font-weight: 200;
      text-align: justify;
      @include breakpoint(md) {
        padding: 0 20px;
      }
    }
    h1 {
      position: absolute;
      display: inline-block;
      left: calc(30% - 25px);
      font-size: 50px;
      line-height: 50px;
      color: $indigo;
      top: -25px;
      font-family: 'Autography', Courier, monospace;
      @include breakpoint(md) {
        left: 20px;
      }
    }
    small {
      position: absolute;
      font-size: 15px;
      font-weight: 200;
      font-style: italic;
      color: lighten($sage, 10%);
      transform: translateX(50%) rotate(270deg) translateX(50%);
      right: 20px;
      bottom: 10px;
    }
    &:after {
      position: absolute;
      z-index: -10;
      top: 0;
      right: 0;
      width: 70%;
      height: 100%;
      content: '';
      background: $accent-block;
      @include breakpoint(md) {
        width: 100%;
      }
    }
    &:before {
      position: absolute;
      top: 40px;
      right: -20px;
      width: 40px;
      height: 3px;
      content: '';
      background: $gold;
      @include breakpoint(md) {
        top: 30px;
      }
    }
  }
  .value {
    margin: 0 0 200px 0;
    position: relative;
    display: flex;
    align-items: center;
    @include breakpoint(md) {
      display: block;
    }
    .value-text {
      display: flex;
      width: 75%;
      margin: 40px;
      @include breakpoint(md) {
        width: 100%;
        display: block;
        margin: 0;
        padding: 60px 20px 20px 20px;
      }
      p {
        column-count: 2;
        column-gap: 40px;
        font-weight: 200;
        text-align: justify;
        @include breakpoint(md) {
          column-count: initial;
          column-gap: 20px;
        }
      }
    }
    .value-cards {
      width: 25%;
      flex: 25%;
      @include breakpoint(md) {
        width: 100%;
        position: relative;
        padding: 0 20px 20px 20px;
      }
      li {
        width: 100%;
        margin: 20px 0;
        padding: 10px;
        display: block;
        background: $white;
        box-shadow: 0px 0px 15px 3px rgba($black, 0.2);
        border-radius: 3px;
        p {
          color: $sage;
          @include breakpoint(md) {
            text-align: center;
          }
        }
        small {
          color: $sage;
          font-style: 10px;
          line-height: 1rem;
          font-weight: 200;
          font-style: italic;
          @include breakpoint(md) {
            text-align: center;
            display: block;
          }
        }
      }
    }
    h1 {
      position: absolute;
      display: inline-block;
      left: 0;
      font-size: 50px;
      line-height: 50px;
      color: $indigo;
      top: -25px;
      font-family: 'Autography', Courier, monospace;
      @include breakpoint(md) {
        left: 20px;
      }
    }
    &:after {
      position: absolute;
      z-index: -10;
      top: 0;
      left: 0;
      width: calc(100% - 40px);
      height: 100%;
      content: '';
      background: $accent-block;
      @include breakpoint(md) {
        width: 100%;
      }
    }
    &:before {
      position: absolute;
      bottom: -20px;
      left: 40px;
      height: 40px;
      width: 3px;
      content: '';
      background: $gold;
      @include breakpoint(md) {
        left: 20px;
      }
    }
  }
}
</style>
